import React from 'react';

import { Box, Flex, xcss } from '@atlaskit/primitives';

import { type CardProps } from './types';

const containerStyles = xcss({
	position: 'relative',
	width: '360px',
	padding: 'space.300',
});

const controlsStyles = xcss({
	position: 'absolute',
	top: 'space.200',
	right: 'space.200',
});

const Card = ({ content, controls, ...a11yProps }: CardProps) => {
	return (
		<Box xcss={containerStyles} {...a11yProps}>
			<Flex xcss={controlsStyles} alignItems="center" justifyContent="end" columnGap="space.050">
				{controls}
			</Flex>
			{content}
		</Box>
	);
};

export { Card };
